import React from 'react'
import PropTypes from 'prop-types'
import styles from '../WideLayout.module.scss'
import clsx from 'clsx'

export const Content = ({ className = '', children = null, centered = false }) => (
  <section className={className}>
    <div
      className={clsx(styles['side-content-wrapper'], {
        [styles['side-content-wrapper_left']]: !centered,
      })}
    >
      {children}
    </div>
  </section>
)

Content.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
  centered: PropTypes.bool,
}
